import React, { createContext, useContext, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {

  const [session, setSession] = useState(() => {
    const savedSession = localStorage.getItem("session");
    return savedSession
      ? JSON.parse(savedSession)
      : {
          sessionId: null,
          prof: '',
          course: '',
          yearLevel: '',
          section: '',
          subject: '',
          roomId: ''
        };
  });

  const updateSession = (updates) => {
    setSession(prev => {
      const updatedSession = {
        ...prev,
        ...updates,
        sessionId: prev.sessionId || uuidv4(),
      };

      localStorage.setItem("session", JSON.stringify(updatedSession));
      return updatedSession;
    });
  };

  const clearSession = () => {
    const empty = {
      sessionId: null,
      prof: '',
      course: '',
      yearLevel: '',
      section: '',
      subject: '',
      roomId: ''
    };

    localStorage.removeItem("session");
    setSession(empty);
  };

  return (
    <SessionContext.Provider value={{ session, updateSession, clearSession }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);

export default SessionContext;